<ng-container *ngIf="showAlert$ | async">
  <ng-container *ngIf="{ type: type$ | async, title: title$ | async, body: body$ | async } as data">
    <py-alert-message
      [title]="data.title"
      [body]="data.body"
      [type]="data.type"
      [dismissable]="dismissable$ | async"
      (dismiss)="onAlertDismiss(data.type, data.body)"
    ></py-alert-message>
  </ng-container>
</ng-container>
